
export const authScreenStyles = {
    appScreen: {
        minHeight: "100dvh",
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column",
    },
    main: {
        flex: 1,
        display: "flex",
    },
    paper: {
        width: { xs: "100%", md: 448 },
        minHeight: { xs: "auto", md: "688" },
        borderRadius: 2,
        px: { xs: 2, md: 4 },
        py: { xs: 2, md: 5 },
    },
    container: {
        flex: 1,
    },
    formContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pt: { xs: 2, md: 0 },
        mt: { xs: 4, md: 0 },  
        minHeight: "100%",  
    },
    bgImageContainer: {
        display: { xs: "none", md: "block" },
        position: "relative",
    },
    bgImage: (backgroundImage: string) => ({
        position: "absolute",
        inset: 0,
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
    }),
    overlay: {
        position: "absolute",
        top: 0,
        left: 0,
        width: 720,
        height: "100%",
        background:
            "linear-gradient(90deg, #FFFFFFFF 0%, #FFFFFF80 50%, #FFFFFF00 100%)",
    },
    footer: {
        borderTop: "1px solid rgba(23,26,31,0.08)",
        px: { xs: 2, md: 4 },
        py: 2,
        pb: "calc(env(safe-area-inset-bottom, 0px) + 16px)",
        backgroundColor: "#fff",
    },
    form: {
        width: "100%",
    },
    logo: {
        height: 120,
        display: "block",
        mx: "auto",
    },
    heading: {
        fontSize: 36,
        lineHeight: "40px",
        fontWeight: 700,
        color: "#171A1F",
        mt: 4,
        textAlign: "center",
    },
    subheading: {
        fontSize: 18,
        lineHeight: "28px",
        // fontWeight: 400,
        color: "#565D6D",
        my: 2,
        textAlign: "center",

        "fontFamily": "'Roboto', sans-serif",
        "textTransform": "uppercase",
        "fontWeight": "400",
        "letterSpacing": "1px",
        "marginBottom": "0.5em",

    },
    alert: {
        marginTop: 2, // 1 = 8px
        marginBottom: 2
    },
    linkContainer: {
        mt: 3,
        textAlign: "center",
    },
    link: {
        color: "#1976d2",
        textDecoration: "none",
    },
    submitButton: {
        height: "56px",
        backgroundColor: "#1C4FA6",
        mt: { xs: 1, md: 3 }
    },
};